/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {CustomErrors} from "../../constant/custom-errors";
import {ActivatedRoute} from "@angular/router";
import {RedirectionService} from "../../services/redirection.service";
import {SessionService} from "../../services/session.service";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  constructor(private route: ActivatedRoute, private redirectionService: RedirectionService, private sessionService: SessionService) {
  }

  reason: any;
  isCancellationError: any

  private isSession: any

  ngOnInit(): void {
    var isSession = false;

    this.isCancellationError = false;

    switch (this.route.snapshot.params['reason']) {
      case CustomErrors.invalidSession:
        this.reason = 'validation.error.invalid.session';
        isSession = false;
        break;
      case CustomErrors.unreachableService:
        this.reason = 'error.unreachable';
        isSession = true;
        break;
      case CustomErrors.unexpectedError:
        this.reason = 'error.unexpected';
        isSession = true;
        break;
      case CustomErrors.totalSubmissionLimitOtp:
        this.reason = 'document-display.sign.otp.max-end';
        isSession = false;
        break;
      case CustomErrors.evidenceError:
        this.reason = 'error.evidences.fail';
        isSession = false;
        break;
      case CustomErrors.cancellationError:
        this.reason = 'error.pending-cancellation';
        this.isCancellationError = true;
        isSession = false;
        break;
      case CustomErrors.totalSSOLimit:
        this.reason = 'document-display.sso.error.limit';
        isSession = false;
        break;
      default:
        break;
    }

    console.debug('reason: ' + this.reason);
  }

  info() {
    return typeof (this.reason) !== 'undefined';
  };

  // don't Check the sessionId (may be not reachable)


  // return to process flow
  back() {
    var sessionId = this.route.snapshot.params['sessionId'];
    this.redirectionService.session(this.route, sessionId);
  };

  existsSession() {
    return this.isSession;
  };

  existsSubscriberErrorPage() {

    if (typeof this.sessionService.info === 'undefined') {
      return false;
    }
    var urlKo = this.sessionService.info.urlKo;
    return (typeof urlKo !== 'undefined' && urlKo !== null);
  };

  //exit (definitively...)
  exit() {
    if (typeof this.sessionService.info !== 'undefined') {
      var url;
      if (this.isCancellationError) {
        url = this.sessionService.getUrlCancel();
      } else {
        url = this.sessionService.getUrlKo();
      }
      this.redirectionService.exit(url);
    }
  };

}
